import React from "react";
import ConferenceRoom from "./ConferenceRoom";

/**
 * KidsTutoringRoom — kid-branded wrapper around ConferenceRoom.
 *
 * Same WebRTC mesh signaling and video tiles, wrapped in a playful
 * gradient backdrop + the official "Tap IN Learn and Play" logo so kids
 * feel at home. Because ConferenceRoom uses useParams().mid to load the
 * meeting, and the meeting doc we create with kind='kids_tutor' lives
 * in the same `meetings` collection, it Just Works™.
 */
export default function KidsTutoringRoom() {
  return (
    <div data-testid="kids-tutoring-room" className="relative min-h-screen">
      {/* Kid-safe accent border around the whole meeting. Narrow enough
          that it doesn't push the video grid or steal click targets. */}
      <div aria-hidden className="pointer-events-none fixed inset-0 z-40 border-[6px] rounded-none"
        style={{ borderImage: "linear-gradient(135deg,#ec4899,#f59e0b,#22d3ee,#8b5cf6) 1" }} />
      {/* Branded logo badge — top-left below header */}
      <div className="fixed top-[76px] left-4 z-50 pointer-events-none drop-shadow-2xl">
        <img
          src="/kids-learn-play-logo.png"
          alt="Tap IN Learn and Play"
          data-testid="kids-tutor-logo"
          className="w-[92px] sm:w-[120px] h-auto select-none"
          draggable={false}
        />
      </div>
      <ConferenceRoom />
    </div>
  );
}
